import Button from '@/components/Buttons/Button';
import BootstrapDialog from '@/components/Dialog/BootstrapDialog';
import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import Close from '@/images/Close.svg';
import styled from '@emotion/styled';
import { DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material';

const Header = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;

    color: ${({ theme }) => theme.colors.black.main};
    font-size: 24px;
    font-weight: 600;
    letter-spacing: -0.48px;

    button {
        color: ${({ theme }) => theme.colors.black.main};
    }
`;

const StyledVideo = styled.video`
    border-radius: 8px;
    outline: none;
    height: min-content;

    ::cue {
        text-shadow:
            -1px -1px 0 #000,
            1px -1px 0 #000,
            -1px 1px 0 #000,
            1px 1px 0 #000;
    }
`;

const StyledDialog = styled(BootstrapDialog)`
    & .MuiPaper-root {
        padding: 24px;
        box-sizing: content-box;
        max-width: 1024px;
        max-height: 720px;
        border-radius: 2rem;

        @media (max-height: 780px) {
            margin: 12rem 0;
            background: #f1f2f6;
            height: 80%;
        }
    }
`;

const StyledButton = styled(Button)`
    margin-left: auto;
`;

const StyledDialogTitle = styled(DialogTitle)`
    padding: 0px !important;
`;

const StyledDialogContent = styled(DialogContent)`
    padding: 0px !important;
`;

const StyledDialogActions = styled(DialogActions)`
    margin-top: 1rem;
    padding: 0px !important;
`;

interface Props {
    isOpen: boolean;
    handleClose: () => void;
    src: string;
    thumbnail: string;
    title: string;
    autoplay?: boolean;
    button?: {
        label: string;
        onClick: () => void;
    };
}

export const SimpleVideoPlayerModal = ({ src, thumbnail, title, autoplay, isOpen, handleClose, button }: Props) => {
    const handleVideoLoaded = (event: any) => {
        const target = event.target as HTMLVideoElement;
        target.currentTime = 0;
        target.controls = true;

        if (autoplay) {
            target.play();
        }
    };

    return (
        <StyledDialog onClose={handleClose} open={isOpen}>
            <StyledDialogTitle>
                <Header>
                    {title}

                    <IconButton onClick={handleClose}>
                        <MaskedIcon src={Close} size="20px" />
                    </IconButton>
                </Header>
            </StyledDialogTitle>
            <StyledDialogContent>
                <StyledVideo
                    preload="auto"
                    onLoadedMetadata={handleVideoLoaded}
                    width="100%"
                    height="100%"
                    poster={thumbnail}
                    controls={false}
                    controlsList="nodownload"
                    crossOrigin="use-credentials"
                    playsInline
                    autoPlay={autoplay}>
                    <source src={src} type="video/mp4" />
                    Your browser does not support the video tag.
                </StyledVideo>
            </StyledDialogContent>
            {!!button && (
                <StyledDialogActions>
                    <StyledButton variant="contained" color="primary" onClick={button.onClick}>
                        {button.label}
                    </StyledButton>
                </StyledDialogActions>
            )}
        </StyledDialog>
    );
};
